import { NewTab, PageTab, PageTabAdv } from "../../../../components";
import GeneratSettings from "./ConfigurationTabs/GeneralSettings";
import Integration from "./ConfigurationTabs/Integration";
import Automation from "./ConfigurationTabs/Automation";
import GlobalSettings from "./ConfigurationTabs/GlobalSettings";
import { useModuleAccess } from "../../../../hooks";
import { getItem } from "../../../../utils/localStorageUtils";

const Configurations = () => {
  const portal = getItem("portal");
  const DashboardMenus = [
    {
      title: "Automation",
      page: <Automation />,
      type: "main",
      id: "settings_configurations_automation",
    },
    {
      title: "Global Settings",
      page: <GlobalSettings />,
      type: "main",
      id: "settings_configurations_globalsettings",
    },
    {
      title: "General Settings",
      page: <GeneratSettings />,
      type: "main",
      id: "settings_configurations_generalsettings",
    },
    {
      title: "Integration",
      page: <Integration />,
      type: "main",
      id: "settings_configurations_integration",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: DashboardMenus,
    parentId: "settings_configurations",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  return (
    <div className="overflow-hidden flex flex-1 py-2">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="configurations"
      />
    </div>
  );
};

export default Configurations;
